/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
import { EmailSchema } from './Email.schema';
import { PhoneNumberSchema } from './PhoneNumber.schema';
import { AddressSchema } from './Address.schema';
const baseSchema = z.object({
    createdAt: z.coerce.date().default(() => new Date()),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string().optional(),
    emails: z.array(z.lazy(() => EmailSchema)),
    phoneNumbers: z.array(z.lazy(() => PhoneNumberSchema)),
    addresses: z.lazy(() => AddressSchema).nullish(),
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string().optional(),
    emails: z.array(z.lazy(() => EmailSchema)),
    phoneNumbers: z.array(z.lazy(() => PhoneNumberSchema)),
    addresses: z.lazy(() => AddressSchema).nullish(),
}
).strict();
const relationSchema = z.object({
    user: z.record(z.string(), z.unknown()),
}
);
const fkSchema = z.object({
    id: z.string().optional(),
}
);

/**
 * `Profile` schema excluding foreign keys and relations.
 */
export const ProfileScalarSchema = baseSchema;


/**
 * `Profile` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const ProfileSchema = ProfileScalarSchema.merge(fkSchema).merge(relationSchema.partial());


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const ProfilePrismaCreateSchema = baseSchemaWithoutDefaults.partial().passthrough();


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const ProfilePrismaUpdateSchema = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string().optional(),
    emails: z.array(z.lazy(() => EmailSchema)),
    phoneNumbers: z.array(z.lazy(() => PhoneNumberSchema)),
    addresses: z.lazy(() => AddressSchema).nullish()
}).partial().passthrough();


/**
 * `Profile` schema for create operations excluding foreign keys and relations.
 */
export const ProfileCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    createdAt: true, createdById: true, updatedAt: true, updatedById: true, id: true, emails: true, phoneNumbers: true
});


/**
 * `Profile` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const ProfileCreateSchema = ProfileCreateScalarSchema.merge(fkSchema);


/**
 * `Profile` schema for update operations excluding foreign keys and relations.
 */
export const ProfileUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `Profile` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const ProfileUpdateSchema = ProfileUpdateScalarSchema.merge(fkSchema.partial());

